import i18nFactory from '@yandex-int/i18n';
import moment from 'moment';

import { LangUtils } from '../../service/Lang/Lang';
import {
    GdMenuItem,
    HeaderClientInfoQuery,
    HeaderInfoQuery,
    MenuHeaderQuery
} from '../../typings/graphql-grid';
import {
    HeaderInfoBlockApiData,
    HeaderInfoBlockData,
    HeaderInfoBlockNewsItemApiData,
    HeaderInfoBlockNewsItemData,
    HeaderInfoBlockNewsItemDataApiData,
    HeaderInfoData
} from '../../typings/header';
import { mapApiWalletsToWalletData } from '../common/common';

import * as keyset from './header.i18n';

const i18n = i18nFactory(keyset);

export function mapInfoBlockApiData(
    headerData: HeaderInfoBlockApiData
): HeaderInfoBlockData {
    const {
        result: {
            news: { items },
            show_block
        }
    } = headerData;
    const defaultInfoBlockNews: HeaderInfoBlockData = {
        news: {
            itemsQueue: [],
            items: []
        },
        isInfoBlockAvailable: show_block
    };

    if (items.length) {
        let hasNewItems = false;

        const data = items.reduce(
            (
                res: HeaderInfoBlockData,
                item: HeaderInfoBlockNewsItemApiData
            ) => {
                if (!item.data) {
                    res.news.itemsQueue.push({
                        id: item.ext_news_id
                    });
                } else {
                    item.data.date = mapInfoBlockDateToValidFormat(
                        item.data.date
                    );

                    if (item.new) {
                        hasNewItems = true;
                    }

                    res.news.items.push(
                        mapInfoBlockApiNewsData(item.data, item.new)
                    );
                }

                return res;
            },
            defaultInfoBlockNews
        );

        return {
            ...data,
            hasNewItems,
            isInfoBlockAvailable: show_block
        };
    } else {
        return defaultInfoBlockNews;
    }
}

export function mapInfoBlockDateToValidFormat(date: string): string {
    const langsFormats = {
        ru: 'DD MMMM YYYY',
        en: 'MMMM DD YYYY',
        ua: 'DD MMMM YYYY',
        tr: 'DD MMMM YYYY'
    };
    const currentLang = LangUtils.getCurrentLang();

    return moment(date, langsFormats[currentLang] || 'DD MMMM YYYY').calendar(
        undefined,
        {
            sameDay: '[' + i18n('today') + ']',
            lastDay: '[' + i18n('yesterday') + ']',
            lastWeek: 'DD MMMM YYYY',
            nextDay: '[' + i18n('tomorrow') + ']',
            nextWeek: 'DD MMMM YYYY',
            sameElse: 'DD MMMM YYYY'
        }
    );
}

export function mapInfoBlockApiNewsData(
    newsData: HeaderInfoBlockNewsItemDataApiData,
    isNew: boolean
): HeaderInfoBlockNewsItemData {
    const { date, content } = newsData;
    const [newsContent] = content;

    return {
        href: newsContent.link_url,
        description: newsContent.text,
        title: date,
        isNew
    };
}

export function mapCurrentUserApiData(
    data: HeaderInfoQuery,
    menuData: MenuHeaderQuery
): HeaderInfoData {
    return {
        clientId: data.client.info.chiefUserId,
        chiefUserId: data.operator.info ? data.operator.info.userId : undefined,
        dealsTotalCount: data.client.deals.totalCount,
        allowedMenuItems: mapAllowedMenuItems(
            menuData.menuHeader.allowedMenuItems
        ),
        isB2bBalanceCartEnabled: data.client.features.isB2bBalanceCartEnabled,
        canSeeDealsLinkEverywhere: data.client.access.canSeeDealsLinkEverywhere,
        wallet: mapApiWalletsToWalletData(data.client.wallets),
        isAgency: data.operator.isAgency,
        agencyId: data.client.info.agencyClientId || undefined
    };
}

export function mapCurrentUserAndClientApiData(
    data: HeaderInfoQuery,
    menuData: MenuHeaderQuery,
    clientData: HeaderClientInfoQuery
): HeaderInfoData {
    return {
        clientId: clientData.client.info.chiefUserId,
        chiefUserId: data.operator.info ? data.operator.info.userId : undefined,
        dealsTotalCount: data.client.deals.totalCount,
        allowedMenuItems: mapAllowedMenuItems(
            menuData.menuHeader.allowedMenuItems,
            data.operator.isAgency
        ),
        isB2bBalanceCartEnabled: data.client.features.isB2bBalanceCartEnabled,
        canSeeDealsLinkEverywhere: data.client.access.canSeeDealsLinkEverywhere,
        wallet: mapApiWalletsToWalletData(clientData.client.wallets),
        isAgency: data.operator.isAgency,
        agencyId: clientData.client.info.agencyClientId || undefined
    };
}

export function mapAllowedMenuItems(
    allowedMenuItems: GdMenuItem[],
    isAgency?: boolean
): GdMenuItem[] {
    const newAllowedMenuItems =
        allowedMenuItems.filter(item => {
            return item !== GdMenuItem.RECOMMENDATIONS;
        }) || [];

    // Правильный расчет доступности таба для рекомендаций
    if (!isAgency) {
        newAllowedMenuItems.push(GdMenuItem.RECOMMENDATIONS);
    }

    return newAllowedMenuItems;
}
